import React from "react";
import { TitleThickThin } from "@components/titles";
import Link from "next/link";
import Button from "@components/Button";
import { CPagesPath } from "shared/models/const/pages-path";
import { useTranslations } from "next-intl";
import WsSectionTitleWithThinTitle from "@components/a1-refactor/typography/WsSectionTitleWithThinTitle copy";
import { Box, Grid, Stack, styled, Typography, useTheme } from "@mui/material";

const BankLogos = [
  { src: "/icons/banco_popular_logo.svg", alt: "Logo Banco Popular" },
  { src: "/icons/banco_reservas_logo.svg", alt: "Logo Banco Reservas" },
  { src: "/icons/banco_bhd_logo.svg", alt: "Logo Banco BHD" },
  { src: "/icons/scotiabank_logo.svg", alt: "Logo ScotiaBank" },
];

function CoverSection() {
  const translation = useTranslations("mortgage");
  const translationLoan = useTranslations("mortgage.loan");
  const coverTitle = translation("title") || "";
  const [title, ...rest] = coverTitle.split(" ");

  return (
    <CoverBackground component="article">
      <HeroContent className="cover__content">
        <Grid
          container
          rowSpacing={{
            xs: 2,
            md: 3,
          }}
        >
          <Grid item xs={12}>
            <WsSectionTitleWithThinTitle
              title={title}
              subtitle={rest.join(" ")}
              color="white"
            />
          </Grid>

          <Grid item xs={12} px={2}>
            <HeroDescription variant="body1" color="white">
              {translationLoan("description")}
            </HeroDescription>
          </Grid>

          <Grid item xs={12}>
            <HeroSectionButtons>
              <Link href={CPagesPath.es.loan_form + "#loanForm"} passHref>
                <Button
                  component="a"
                  bg="--color-brand-red-main"
                  className="hero-section-button"
                >
                  {translationLoan("applyForLoan")}
                </Button>
              </Link>
            </HeroSectionButtons>
          </Grid>
        </Grid>
      </HeroContent>
    </CoverBackground>
  );
}

export default CoverSection;

const CoverBackground = styled(Box)({
  width: "100%",
  height: "95vh",
  position: "relative",
  backgroundImage: 'url("/images/image-optimize/bussiness-people.webp")',
  backgroundPosition: "top center",
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  "@media (max-width: 500px)": {
    backgroundPosition: "top center",
    backgroundSize: "contain",
    height: "500px",
  },

  // "@media (max-width: 431px) and (min-width: 430px)": {
  //   height: "60vh",
  //   backgroundPosition: "top center",
  //   backgroundSize: "contain",
  // },
  // "@media (max-width: 415px) and (min-width: 410px)": {
  //   height: "65vh",
  //   backgroundPosition: "top center",
  //   backgroundSize: "contain",
  // },
  "@media (max-width: 450px)": {
    height: "600px",
  },

  "@media (max-width: 431px) and (min-width: 430px)": {
    height: "60vh",
    backgroundPosition: "top center",
    backgroundSize: "contain",
  },
  "@media (max-width: 415px) and (min-width: 410px)": {
    height: "65vh",
    backgroundPosition: "top center",
    backgroundSize: "contain",
  },
  "@media (max-width: 391px) and (min-width: 380px)": {
    height: "70vh",
    backgroundPosition: "top center",
    backgroundSize: "contain",
  },
  "@media (max-width: 361px) ": {
    height: "80vh",
    backgroundPosition: "top center",
    backgroundSize: "contain",
  },
});

const HeroContent = styled(Box)({
  position: "absolute",
  left: "5vw",
  top: "30vh",
  height: "auto",
  width: "501px",
  minHeight: "360px",
  backgroundColor: "var(--color-brand-blue-main)",
  padding: "70px 1rem",

  "@media (max-width: 900px)": {
    display: "flex",
    width: "100%",
    minHeight: "auto",
    padding: "2rem",
    // height: "200px",
    top: "auto",
    bottom: 0,
    left: 0,
  },
});

const HeroDescription = styled(Typography)({
  fontSize: "0.938rem",
  fontWeight: 400,
  lineHeight: "20px",
  textAlign: "justify",
});

const HeroSectionButtons = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: "1rem",
  position: "relative",
  "& .hero-section-button": {
    position: "absolute",
    top: 20,
    "@media (max-width: 900px)": {
      position: "relative",
      top: "auto",
    },
  },
});
